import { _ as _objectWithoutProperties, a as _extends } from '../_rollupPluginBabelHelpers-b0164b33.js';
import React from 'react';
import PropTypes from 'prop-types';
import Bem from '../packages/honey-bem.js';
import { Injecss } from '../packages/injecss.js';

var styles = {
raw: ".hcr-overlay-1-6-0{position:fixed;top:0;left:0;width:100%;height:100%;background:rgba(0,0,0,.15);z-index:1100}",
map:{"hcr-overlay":"hcr-overlay-1-6-0"}};

var bemOverlay = Bem('overlay', styles);
var Overlay = function Overlay(_ref) {
  var extraClasses = _ref.extraClasses,
      rest = _objectWithoutProperties(_ref, ["extraClasses"]);

  return React.createElement("div", _extends({
    className: bemOverlay.b(false, extraClasses)
  }, rest));
};
Overlay.displayName = 'Overlay';
Overlay.defaultProps = {
  extraClasses: null
};
Overlay.propTypes = {
  /** custom class names */
  extraClasses: PropTypes.string
};
var Overlay$1 = Injecss(Overlay, styles);

export { Overlay$1 as Overlay };
